import { forwardRef } from "react";
import { QRCode } from "antd";
import { formatPosterExpiry } from "../../utils/videoReviewPoster";
import { useTranslation } from "../../i18n";
import "./VideoReviewPoster.css";

const VideoReviewPoster = forwardRef(function VideoReviewPoster(
    { videoName, expiresAtLabel, url },
    ref
) {
    const { t } = useTranslation();
    return (
        <div ref={ref} className="video-review-poster">
            <div className="video-review-poster__inner">
                <header className="video-review-poster__header">
                    <div className="video-review-poster__brand">HEI CREATIVE</div>
                    <h1 className="video-review-poster__title">{videoName}</h1>
                    <div className="video-review-poster__subtitle">{t("videoReview.share.poster.subtitle")}</div>
                </header>

                <section className="video-review-poster__qr-section">
                    <div className="video-review-poster__qr-wrapper">
                        <div className="video-review-poster__qr-inner">
                            {url ? (
                                <QRCode
                                    value={url}
                                    size={190}
                                    color="#1d1d1f"
                                    bgColor="#ffffff"
                                    bordered={false}
                                    errorLevel="M"
                                />
                            ) : null}
                        </div>
                    </div>
                    <div className="video-review-poster__qr-text">
                        {t("videoReview.share.poster.scanHint")}
                    </div>
                </section>

                <footer className="video-review-poster__footer">
                    <div className="video-review-poster__divider" />
                    <div className="video-review-poster__expiry">
                        {t("videoReview.share.poster.expiryLabel")} · {formatPosterExpiry(expiresAtLabel)}
                    </div>
                    <div className="video-review-poster__social">
                        <div>小红书 @伦敦摄影师小黑</div>
                        <div>Instagram @Mr.Hei_</div>
                    </div>
                    <div className="video-review-poster__website">HEICREATIVE.CO.UK</div>
                </footer>
            </div>
        </div>
    );
});

export default VideoReviewPoster;
